import './ScoreSelector.css';
import cx from 'classnames';

const ScoreSelector = ({ score, handleScoreSelect }) => {

  return (
     <div className="group-buttons-container">
        {Array.from({ length: 11 }).map((_, index) => {
          const selected = score === index ? 'selected' : '';
          const btnClass = cx(`button ${selected}`);
          return (
            <button
              key={index}
              className={btnClass}
              onClick={() => handleScoreSelect(index)}
            >
              {index}
            </button>
          );
        })}
      </div>
      );
};
export default ScoreSelector;
     
     
     
     
     
     
     
     
     
